type LeaderboardVehicle = {
  uuid: string;
  label: string;
};

export type LeaderboardExercise = {
  uuid: string;
  label: string;
  vehicles: LeaderboardVehicle[];
};

export const LEADERBOARD_EXERCISES: LeaderboardExercise[] = [
  {
    uuid: "ab54cc85-ee2b-4b9e-b0da-53877e998131",
    label: "Gather Rocks Around the Machine - 360° (Time Trial)",
    vehicles: [
      { uuid: "c4f013b986b6b234c98fcf86f7dfd9a9", label: "Excavator" },
      {
        uuid: "4b24c8c0-b281-4429-99fc-6a4a34a0a64f",
        label: "Tracked Excavator",
      },
    ],
  },
  {
    uuid: "28aed055-1dc2-4011-b051-779cfc81e8c3",
    label: "Reverse maneuvering - Farm",
    vehicles: [
      {
        uuid: "b05a22efc0c12e64fa1efbd015471440",
        label: "Truck with 4-Axle Trailer",
      },
      {
        uuid: "eafccf5462892f047954f1cc70ca3b2d",
        label: "Semi-Truck with Trailer 6x4",
      },
      { uuid: "d35d50ec0d03359489dabde92c0a264c", label: "Truck" },
    ],
  },
];

export const DEFAULT_LEADERBOARD_EXERCISE = LEADERBOARD_EXERCISES.find(
  (exercise) => exercise.uuid === "ab54cc85-ee2b-4b9e-b0da-53877e998131",
)!;

export function findLeaderboardExercise(uuid: unknown) {
  return LEADERBOARD_EXERCISES.find((exercise) => exercise.uuid === uuid);
}

export function findLeaderboardVehicle(
  exercise: LeaderboardExercise,
  uuid: unknown,
) {
  return exercise.vehicles.find((vehicle) => vehicle.uuid === uuid);
}
